// EQUIPE_V2_0311 (GROK2): selo de painel/revenda, filtro por painel/revenda e escolha do painel do teste rápido.
// Só exibição/escolha. Os cartões do teste só aparecem quando o backend novo responde teste_painel=true
// (switch private/TESTE_PAINEL_OFF). Rollback: build.bak_EQUIPE_V2_0311_*.
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

const hue = (s) => { let h = 0; const t = String(s || ''); for (let i = 0; i < t.length; i += 1) h = (h * 31 + t.charCodeAt(i)) % 360; return h; };
const curto = (s) => { const t = String(s || '').trim(); const p = t.split(/\s+/); return p.length === 2 && p[0].toLowerCase() === p[1].toLowerCase() ? p[0] : t; };

export function PainelBadge0311({ label, className = '' }) {
  if (!label) return null;
  const h = hue(curto(label));
  return <span data-testid="painel-badge-0311" title={`Painel/revenda: ${label}`} className={`inline-flex max-w-[140px] items-center truncate rounded-full border px-1.5 py-0 text-[10.5px] font-medium leading-4 align-middle ${className}`}
    style={{ background: `hsl(${h} 70% 50% / .14)`, borderColor: `hsl(${h} 70% 50% / .35)`, color: `hsl(${h} 75% 62%)` }}>{curto(label)}</span>;
}

/** Chips "Filtrar por painel/revenda". rows = lista; getLabel(row) -> rótulo. Só aparece com 2+ rótulos. */
export function PainelChips0311({ rows, getLabel, value, onChange, className = '' }) {
  const cont = useMemo(() => { const m = new Map(); (rows || []).forEach((r) => { const l = getLabel(r) || 'Sem revenda'; m.set(l, (m.get(l) || 0) + 1); }); return [...m.entries()].sort((a, b) => b[1] - a[1]); }, [rows, getLabel]);
  useEffect(() => { if (value && !cont.some(([l]) => l === value)) onChange(''); }, [cont, value]); // eslint-disable-line react-hooks/exhaustive-deps
  if (cont.length < 2 && !value) return null;
  const chip = (on) => `whitespace-nowrap text-xs px-2.5 py-1 rounded-full border transition ${on ? 'bg-primary text-primary-foreground border-primary' : 'border-border hover:bg-muted'}`;
  return <div className={`mb-2 ${className}`} data-testid="painel-filtro-0311">
    <div className="mb-1 text-[11px] font-medium text-muted-foreground">Filtrar por painel/revenda</div>
    <div className="flex gap-1.5 overflow-x-auto pb-1">
      <button type="button" className={chip(!value)} onClick={() => onChange('')}>Todos <b className="ml-1">{(rows || []).length}</b></button>
      {cont.map(([l, n]) => <button key={l} type="button" className={chip(value === l)} onClick={() => onChange(l)}>{curto(l)} <b className="ml-1">{n}</b></button>)}
    </div>
  </div>;
}

export const TESTE_KEY_0311 = 'painel_teste_0211';
export function painelTesteId0311() { try { return localStorage.getItem(TESTE_KEY_0311) || ''; } catch (e) { return ''; } }
let equipeCache0311 = null;
/** Corpo extra para POST /api/xui/quick-test/one-click (vazio = próprio painel). */
export function painelTesteBody0311() {
  const id = painelTesteId0311();
  if (!id || !equipeCache0311?.teste_painel) return {};
  if (!(equipeCache0311.paineis || []).some((p) => p.id === id)) return {};
  return { painel_0211: id };
}

export function PainelTesteCards0311({ className = '' }) {
  const [eq, setEq] = useState(equipeCache0311);
  const [sel, setSel] = useState(painelTesteId0311());
  useEffect(() => {
    let vivo = true;
    axios.get(`${API_BASE_URL}/api/equipe-paineis`, { withCredentials: true, timeout: 10000 })
      .then(({ data }) => { equipeCache0311 = data || {}; if (vivo) setEq(equipeCache0311); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  const paineis = eq?.paineis || [];
  useEffect(() => { if (eq && sel && !paineis.some((p) => p.id === sel)) { setSel(''); try { localStorage.removeItem(TESTE_KEY_0311); } catch (e) {} } }, [eq]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!eq?.teste_painel || !paineis.length) return null;
  const escolher = (id) => { setSel(id); try { if (id) localStorage.setItem(TESTE_KEY_0311, id); else localStorage.removeItem(TESTE_KEY_0311); } catch (e) {} };
  const card = (on) => `flex min-w-[96px] shrink-0 flex-col items-start rounded-xl border px-3 py-2 text-left transition ${on ? 'border-primary bg-primary/10 ring-1 ring-primary/40' : 'border-border hover:bg-muted'}`;
  return <div className={`mb-3 ${className}`} data-testid="painel-teste-0311">
    <div className="mb-1.5 text-xs font-semibold">Criar o teste em qual painel?</div>
    <div className="flex gap-2 overflow-x-auto pb-1">
      <button type="button" className={card(!sel)} onClick={() => escolher('')}><span className="text-sm font-semibold">Meu painel</span><span className="text-[10.5px] text-muted-foreground">próprio</span></button>
      {paineis.map((p) => <button key={p.id} type="button" className={card(sel === p.id)} onClick={() => escolher(p.id)}>
        <span className="max-w-[120px] truncate text-sm font-semibold">{curto(p.nome)}</span>
        <span className="text-[10.5px] text-muted-foreground">{p.saldo != null ? `${p.saldo} créditos` : 'equipe'}</span>
      </button>)}
    </div>
    <div className="mt-1 text-[10.5px] text-muted-foreground">O teste nasce no painel escolhido e as renovações seguem nele.</div>
  </div>;
}
